import { ApolloClient, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { OPERATIONS_FILTER_QUERY } from "graphql/operationsFilter";

const getBearerToken = () => {
  try {
    return localStorage.getItem("accessToken") || "";
  } catch {
    return "";
  }
};

let operationsFilterClient = null;

const getOperationsFilterClient = () => {
  if (operationsFilterClient) {
    return operationsFilterClient;
  }

  const httpLink = createHttpLink({
    uri: process.env.REACT_APP_DOORSHARP_GRAPHQL_ENDPOINT,
  });

  const authLink = setContext((_, { headers }) => ({
    headers: {
      ...headers,
      "Content-Type": "application/json",
      ...(getBearerToken() ? { Authorization: `Bearer ${getBearerToken()}` } : {}),
    },
  }));

  operationsFilterClient = new ApolloClient({
    link: from([authLink, httpLink]),
    cache: new InMemoryCache(),
    defaultOptions: {
      query: {
        fetchPolicy: "network-only",
        errorPolicy: "all",
      },
    },
  });

  return operationsFilterClient;
};

export async function fetchOperationsFilter() {
  try {
    const client = getOperationsFilterClient();

    const { data } = await client.query({
      query: OPERATIONS_FILTER_QUERY,
      fetchPolicy: "network-only",
    });

    console.log("Operations Filter GraphQL response:", data);
    return data;
  } catch (error) {
    console.error("Operations Filter GraphQL error:", error);
    throw error;
  }
}


